/* eslint-disable no-else-return */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-undef */
/* eslint-disable radix */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { FSBTable } from 'components/common/FSBTable';
import {
  EXPORTS_TRADERS,
  UPDATE_TRADER,
  // UPDATE_KYC_STATUS,
  UPDATE_TRADER_KYC_STATUS,
  UPDATE_TRADER_TDS_ELIGIBLE_STATUS,
  UPDATE_WHATSAPP_SUBSCRIPTION,
} from 'pages/Vendor/VendorGraphQL';
import { VENDOR_TYPES, foreignVendorColumns } from 'pages/Vendor/constants';
import StatusFormatter from 'components/StatusFormatter';
// import ActionsFormatter from 'components/ActionsFormatter';
import { toast } from 'react-toastify';
import { STATUS_UPDATED_SUCCESSFULLY } from 'components/common/FSBToastify/types';
import Loader from 'components/common/Loader';
import {
  TRADER_KYC_STATUS,
  handleKycStatusColor,
  handleTraderTypeColor,
  showSequenceNumber,
} from 'utils/constants';
import { setVendorDetails } from 'actions/vendorDetailsAction';
import { useDispatch } from 'react-redux';
import { cloneDeep, isEmpty } from 'lodash';
import { VENDORS_QUERY, VENDORS_QUERY_SUBSCRIPTION } from 'utils/CommonGraphQL';
import DownloadCSV from 'components/DownloadCSV';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import RBAC from 'hoc/RBAC';
import { role } from 'config/role';
import FlagCell from 'pages/Vendor/components/FlagCell';
// import DeleteVendorList from 'pages/Vendor/components/DeleteVendorList';
// import SubscriberCheckbox from 'pages/Vendor/components/SubscriberCheckbox';
// import DeactivatePlanVendorList from 'pages/Vendor/components/DeactivatePlanVendorList';
// import SendEmailToVendors from 'pages/Vendor/components/SendEmailToVendors';
import VendorActionDropdown from 'pages/Vendor/components/VendorActionDropdown';
import { FaCheck, FaChevronDown } from 'react-icons/fa6';
import PaymentTermField from 'components/PaymentTermField';
import axios from 'axios';
import { authContext } from 'contexts/AuthContext';
import moment from 'moment';
import NonRegisteredBadge from 'pages/MarketListing/components/NonRegisteredBadge';
import '../../../CommonVendor/components/CommonVendorTable/mobile.css';
import { trackKycStatusChange, trackUserTypeChange } from 'utils/clevertapEvents';

const MOBILE_FOREIGN_VENDOR_TABS = [
  'Identity',
  'Plan',
  'App Info',
  'Compliance',
];

const FOREIGN_VENDOR_EDIT_ROLES = [
  role.SUPER_ADMIN,
  role.ADMIN,
  role.SALES_HEAD,
];

const getVendorDisplayName = (vendor) => {
  const fullName =
    `${vendor?.firstName || ''} ${vendor?.lastName || ''}`.trim();
  return fullName || vendor?.tradeName || vendor?.entityName || 'N/A';
};

const getVendorPhone = (vendor) => {
  if (!vendor?.phone) return 'No phone';
  return `${vendor?.callingCode?.callingCode || vendor?.callingCodeId || ''}${vendor?.callingCode?.callingCode || vendor?.callingCodeId ? '-' : ''}${vendor?.phone}`;
};

const getVendorOs = (vendor) =>
  vendor?.userDevices?.find((device) => device?.osType)?.osType || null;

const getVendorAppVersion = (vendor) =>
  vendor?.userDevices?.find((device) => device?.appVersion)?.appVersion ||
  'N/A';

const getVendorPlanName = (vendor) =>
  vendor?.latestUserSubscription?.subscriptionPlan?.planName || 'No Plan';

const getVendorTag = (vendor) => {
  const traderTags = vendor?.traderTags;
  return Array.isArray(traderTags) ? traderTags[0] : traderTags;
};

const getFormattedDateTime = (value) => {
  if (!value) return 'N/A';
  return moment(value).format('D MMM, YYYY hh:mm A');
};

const getFormattedDate = (value) => {
  if (!value) return 'N/A';
  return moment(value).format('D MMM, YYYY');
};

const getTdsEligibleLabel = (vendor) => {
  if (!vendor?.isParentTrader) return 'N/A';
  return vendor?.tdsEligible ? 'Yes' : 'No';
};

const getMobileStatusClass = (value) => {
  const normalizedValue = `${value || ''}`.toLowerCase();

  if (
    normalizedValue.includes('active') ||
    normalizedValue.includes('enabled') ||
    normalizedValue === 'yes' ||
    normalizedValue === 'android' ||
    normalizedValue === 'vendor' ||
    normalizedValue === 'seller' ||
    normalizedValue === 'buyer' ||
    normalizedValue === 'trader'
  ) {
    return 'success';
  }

  if (
    normalizedValue.includes('pending') ||
    normalizedValue.includes('trial') ||
    normalizedValue.includes('net')
  ) {
    return 'warning';
  }

  if (
    normalizedValue.includes('rejected') ||
    normalizedValue.includes('deleted') ||
    normalizedValue.includes('inactive') ||
    normalizedValue === 'no'
  ) {
    return 'danger';
  }

  return 'muted';
};

const getForeignVendorMobileSections = (vendor, index, filters) => {
  const sequenceNumber =
    ((filters?.pageNo || 1) - 1) * (filters?.pageSize || 10) + index + 1;

  return {
    Identity: [
      { label: 'S.No', value: sequenceNumber },
      { label: 'Flag', value: getVendorTag(vendor), control: 'flag' },
      { label: 'Vendor ID', value: vendor?.id || 'N/A' },
      { label: 'Vendor name', value: getVendorDisplayName(vendor) },
      {
        label: 'Business name',
        value: vendor?.tradeName || vendor?.entityName || 'N/A',
      },
      { label: 'Phone number', value: getVendorPhone(vendor) },
      { label: 'Created on', value: getFormattedDate(vendor?.createdAt) },
      {
        label: 'Parent trader',
        value: vendor?.parentTrader?.firstName
          ? `${vendor?.parentTrader?.firstName} ${vendor?.parentTrader?.lastName || ''}`.trim()
          : 'N/A',
      },
    ],
    Plan: [
      { label: 'Plan', value: getVendorPlanName(vendor), tone: 'badge' },
      {
        label: 'Activation date',
        value: getFormattedDateTime(
          vendor?.latestUserSubscription?.activationDate,
        ),
      },
      {
        label: 'Plan status',
        value: vendor?.latestUserSubscription?.status || 'N/A',
        tone: 'status',
      },
      {
        label: 'Payment terms',
        value: vendor?.livePaymentTerm?.term || 'N/A',
        control: 'paymentTerms',
      },
    ],
    'App Info': [
      {
        label: 'OS type',
        value: getVendorOs(vendor) || 'N/A',
        tone: getVendorOs(vendor) ? 'badge' : undefined,
      },
      { label: 'App version', value: getVendorAppVersion(vendor) },
      {
        label: 'Whatsapp msg',
        value: vendor?.isWhatsappSubscribed ? 'Enabled' : 'Disabled',
        control: 'whatsapp',
      },
    ],
    Compliance: [
      {
        label: 'TDS eligible',
        value: getTdsEligibleLabel(vendor),
        control: 'tdsEligible',
      },
      {
        label: 'User status',
        value: vendor?.status || 'N/A',
        control: 'userStatus',
      },
      {
        label: 'KYC status',
        value: vendor?.kycStatus || 'N/A',
        control: 'kycStatus',
      },
      { label: 'Role', value: vendor?.traderType || 'Vendor', control: 'role' },
    ],
  };
};

const CommonForeignVendorTable = ({
  searchString,
  // handleViewDetail,
  handleClickEdit,
  toggleDeleteRecord,
  kycStatus,
  type = VENDOR_TYPES.INDIAN,
  drawerEmailToggle,
  toggleDeactivatePlan,
  subscriberType,
  planExpiringType,
  osType,
  traderType,
  dateRange,
  rowSelection,
  setRowSelection,
}) => {
  const tableRef = useRef(null);
  const dispatch = useDispatch();
  const { auth } = useContext(authContext);
  const [expandedCardId, setExpandedCardId] = useState(null);
  const [activeMobileTabs, setActiveMobileTabs] = useState({});
  const [filters, setFilters] = useState({
    filter: [
      // {
      //   key: 'traderSearchFilter',
      //   // joinAttributeName: '',
      //   value: searchString,
      //   type: 'STRING',
      //   op: 'LIKE_OR_NULL',
      // },
      // { key: 'kycStatus', value: kycStatus, type: 'STRING', op: 'EQ' },
      {
        key: 'callingCodeId',
        value: '+91',
        type: 'STRING',
        op: type === VENDOR_TYPES.INDIAN ? 'EQ' : 'NEQ',
      },
      // { ...defaultDeleteFilter },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
  });
  const deviceAndRoleFilters = [
    ...(osType && osType !== 'All'
      ? [{ key: 'osType', value: osType, type: 'STRING', op: 'EQ' }]
      : []),
    ...(traderType && traderType !== 'All'
      ? [{ key: 'traderType', value: traderType, type: 'STRING', op: 'EQ' }]
      : []),
  ];
  const createdAtFilter = (() => {
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    if (!dateRange?.startDate) return [];
    if (!dateRange?.endDate) {
      return [
        { key: 'createdAt', value: formatDate(dateRange.startDate), type: 'DATE', op: 'EQ' },
      ];
    }
    return [
      {
        key: 'createdAt',
        value: `${formatDate(dateRange.startDate)},${formatDate(dateRange.endDate)}`,
        type: 'DATE',
        op: 'BTW',
      },
    ];
  })();

  useEffect(() => {
    setFilters((previousFilters) => ({
      ...previousFilters,
      pageNo: 1,
    }));
  }, [searchString, kycStatus, subscriberType, planExpiringType, osType, traderType, dateRange]);

  const { data, loading, error, refetch, subscribeToMore } = useQuery(
    VENDORS_QUERY,
    {
      variables: {
        ...filters,
        filter: [
          ...filters.filter,
          ...subscriberType,
          ...planExpiringType,
          ...deviceAndRoleFilters,
          ...createdAtFilter,
          { key: 'kycStatus', value: kycStatus, type: 'STRING', op: 'EQ' },
          {
            key: 'traderSearchFilter',
            // joinAttributeName: '',
            value: searchString,
            type: 'STRING',
            op: 'LIKE_OR_NULL',
          },
        ],
      },
      fetchPolicy: 'network-only',
    },
  );

  const [updateTrader] = useMutation(UPDATE_TRADER, {
    onCompleted: () => {
      toast.success('Live Payment Term updated successfully');
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });

  const [updateTraderKycStatus] = useMutation(UPDATE_TRADER_KYC_STATUS, {
    // eslint-disable-next-line no-shadow
    onCompleted: () => {
      toast.success(STATUS_UPDATED_SUCCESSFULLY);
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });

  const [updateTraderTdsEligibleStatus] = useMutation(
    UPDATE_TRADER_TDS_ELIGIBLE_STATUS,
    {
      // eslint-disable-next-line no-shadow
      onCompleted: ({ updateTraderTdsEligibleStatus }) => {
        toast.success(updateTraderTdsEligibleStatus);
      },
      onError: ({ graphQLErrors }) => {
        graphQLErrors.map(({ exception }) => {
          toast.error(exception?.message);
          return exception;
        });
      },
    },
  );

  const [updateTraderWhatsappSubscription] = useMutation(
    UPDATE_WHATSAPP_SUBSCRIPTION,
    {
      // eslint-disable-next-line no-shadow
      onCompleted: ({ updateTraderWhatsappSubscription }) => {
        toast.success(updateTraderWhatsappSubscription);
      },
      onError: ({ graphQLErrors }) => {
        graphQLErrors.map(({ exception }) => {
          toast.error(exception?.message);
          return exception;
        });
      },
    },
  );

  const handleWhatsappChange = async (row) => {
    try {
      await updateTraderWhatsappSubscription({
        variables: {
          traderId: parseInt(row?.id),
          // eslint-disable-next-line no-unneeded-ternary
          isSubscribed: row?.isWhatsappSubscribed ? false : true,
        },
      });
      refetch();
    } catch (err) {
      toast.error(err);
    }
  };

  const handleUserStatusChange = async (row) => {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_REST_API_ENDPOINT}user/update-user-status`,
        {
          userId: row?.id,
          status: row?.status === 'ACTIVE' ? 'DELETED' : 'ACTIVE',
        },
        {
          headers: {
            Authorization: `Bearer ${auth.data.token}`,
          },
        },
      );
      if (!res.error) {
        refetch();
        toast.success('User status updated successfully');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message);
    }
  };

  const whatsappFormatter = (cell) => {
    return (
      <div className="toggle-check cmn-toggle d-flex justify-content-center">
        <div className="d-inline-block position-relative">
          <input
            type="checkbox"
            onChange={() => handleWhatsappChange(cell?.row?.original)}
            // eslint-disable-next-line no-unneeded-ternary
            checked={cell?.row?.original?.isWhatsappSubscribed ? true : false}
          />
          <FaCheck size={10} />
        </div>
      </div>
    );
  };

  const userStatusFormatter = (cell) => {
    return (
      <div className="toggle-check cmn-toggle d-flex justify-content-center">
        <div className="d-inline-block position-relative">
          <input
            type="checkbox"
            onChange={() => handleUserStatusChange(cell?.row?.original)}
            checked={cell?.row?.original?.status === 'ACTIVE' ? true : false}
          />
          <FaCheck size={10} />
        </div>
      </div>
    );
  };

  const handleTDSEligibleStatus = async (row) => {
    if (row?.id)
      try {
        await updateTraderTdsEligibleStatus({
          variables: {
            id: row?.id,
            tdsEligible: row?.tdsEligible ? false : true,
          },
        });
        refetch();
      } catch (err) {
        toast.error(err);
      }
  };

  const tdsEligibleFormatter = (cell) => {
    return cell?.row?.original?.isParentTrader ? (
      <RBAC allowedRoles={[role.SUPER_ADMIN]} disabled>
        {({ access }) => (
          // <StatusFormatter
          //   options={TRADER_TDS_ELIGIBLE_STATUS}
          //   defaultValue={cell?.row?.original?.tdsEligible}
          //   handleChange={(e) => handleTDSEligibleStatus(e, cell)}
          //   inputDisabled={!access}
          // />

          <div className="toggle-check cmn-toggle d-flex justify-content-center">
            <div className="d-inline-block position-relative">
              <input
                type="checkbox"
                onChange={() => handleTDSEligibleStatus(cell?.row?.original)}
                checked={cell?.row?.original?.tdsEligible ? true : false}
                disabled={!access}
              />
              <FaCheck size={10} />
            </div>
          </div>
        )}
      </RBAC>
    ) : (
      <div className="text-center">N/A</div>
    );
  };

  const actionsFormatter = (cell) => {
    return (
      <VendorActionDropdown
        cell={cell}
        handleClickEdit={handleClickEdit}
        toggleDeleteRecord={toggleDeleteRecord}
        drawerEmailToggle={drawerEmailToggle}
        toggleDeactivatePlan={toggleDeactivatePlan}
        showVendorLogin
      />
    );
  };

  const handleKycStatus = async (e, cell) => {
    try {
      const newStatus = e.target.value;
      const prevStatus = cell?.row?.original?.kycStatus;
      await updateTraderKycStatus({
        variables: {
          id: cell?.row?.original?.id,
          userKycStatus: newStatus,
        },
      });
      trackKycStatusChange(cell?.row?.original, prevStatus, newStatus);
      refetch();
    } catch (err) {
      toast.error(err);
    }
  };

  const handleTraderTypeUpdate = async (row, selectedRole) => {
    const userId = row?.id;
    const newTraderType = selectedRole?.toUpperCase();
    const prevType = row?.traderType;

    if (!userId || !newTraderType) return;

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_REST_API_ENDPOINT}trader/update-trader-type/${userId}/${newTraderType}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${auth?.data?.token}`,
          },
        },
      );

      if (res?.data?.error === false || res?.status === 200) {
        toast.success(res?.data?.data || 'User Role updated successfully');
        trackUserTypeChange(row, prevType, newTraderType);
        refetch();
        return;
      }

      toast.error(res?.data?.message || 'Failed to update user role');
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          'Failed to update user role',
      );
    }
  };

  const roleFormatter = (cell) => {
    const ROLE_OPTIONS = [
      { label: 'Buyer', value: 'BUYER' },
      { label: 'Seller', value: 'SELLER' },
      { label: 'Trader', value: 'TRADER' },
    ];
    return (
      <RBAC allowedRoles={FOREIGN_VENDOR_EDIT_ROLES} disabled>
        {({ access }) => (
          <StatusFormatter
            options={ROLE_OPTIONS}
            defaultValue={cell?.row?.original?.traderType}
            handleChange={(e) => {
              handleTraderTypeUpdate(cell?.row?.original, e?.target?.value);
            }}
            inputDisabled={!access}
            isStatus
            handleSelectColor={handleTraderTypeColor}
          />
        )}
      </RBAC>
    );
  };

  const statusFormatter = (cell) => {
    return (
      <RBAC allowedRoles={FOREIGN_VENDOR_EDIT_ROLES} disabled>
        {({ access }) => (
          <StatusFormatter
            options={TRADER_KYC_STATUS}
            // isDisabledOption
            defaultValue={cell?.row?.original?.kycStatus}
            handleChange={(e) => handleKycStatus(e, cell)}
            inputDisabled={!access}
            isStatus
            handleSelectColor={handleKycStatusColor}
          />
        )}
      </RBAC>
    );
  };

  const handleParentTraderClick = (row) => {
    dispatch(
      setVendorDetails({
        status: true,
        selectedVendor: row,
      }),
    );
  };

  const parentTraderFormatter = (cell) => {
    return (
      <>
        {cell?.row?.original?.parentTrader?.firstName ? (
          <div
            className="text-blue-c5 fw-medium cursor-pointer text-nowrap"
            onClick={() =>
              handleParentTraderClick(cell?.row?.original?.parentTrader)
            }
            aria-hidden
          >
            {cell?.row?.original?.parentTrader?.firstName}{' '}
            {cell?.row?.original?.parentTrader?.lastName}
          </div>
        ) : (
          'N/A'
        )}
      </>
    );
  };

  const handlePaymentTerms = async (user, livePaymentTermId) => {
    try {
      await updateTrader({
        variables: {
          trader: {
            id: user?.id,
            livePaymentTerm: livePaymentTermId,
            phone: user?.phone,
            callingCode: user?.callingCode?.id,
          },
        },
      });
      refetch();
    } catch (err) {
      toast.error(err);
    }
  };
  const paymentTermsFormatter = (cell) => {
    return (
      <>
        <PaymentTermField
          defaultValue={
            cell?.row?.original?.livePaymentTerm?.id
              ? {
                  id: cell?.row?.original?.livePaymentTerm?.id,
                  term: cell?.row?.original?.livePaymentTerm?.term,
                }
              : ''
          }
          handleChange={(e) => {
            handlePaymentTerms(cell?.row?.original, e?.id);
          }}
          isDisabled={
            cell?.row?.original?.isParentTrader === true ? false : true
          }
        />
      </>
    );
  };

  const handleLinkClick = (row) => {
    dispatch(
      setVendorDetails({
        status: true,
        selectedVendor: row,
      }),
    );
  };
  const linkFormatter = (cell) => {
    return (
      <>
        {cell?.row?.original?.firstName ? (
          <>
            <div
              className="text-blue-c5 fw-medium cursor-pointer text-nowrap"
              onClick={() => handleLinkClick(cell?.row?.original)}
              aria-hidden
            >
              {cell?.row?.original?.firstName} {cell?.row?.original?.lastName}
            </div>
            {cell?.row?.original?.phone && (
              <p className="mb-0 mt-1 f-12 font-manrope text-active">
                {' '}
                {cell?.row?.original?.callingCodeId}-
                {cell?.row?.original?.phone}
              </p>
            )}
            {cell?.row?.original?.isNonRegistered && <NonRegisteredBadge />}
          </>
        ) : (
          'N/A'
        )}
      </>
    );
  };

  const findIndexOfItem = (item) => {
    return foreignVendorColumns.findIndex((itm) => itm.accessorKey === item);
  };

  const applyColumnCell = (columnKey, cellRenderer) => {
    const index = findIndexOfItem(columnKey);
    if (index >= 0) {
      foreignVendorColumns[index].cell = cellRenderer;
    }
  };

  applyColumnCell('isParentTrader', parentTraderFormatter);
  applyColumnCell('kycStatus', statusFormatter);
  applyColumnCell('role', roleFormatter);
  applyColumnCell('paymentTerms', paymentTermsFormatter);
  applyColumnCell('tdsEligible', tdsEligibleFormatter);
  applyColumnCell('isWhatsappSubscribed', whatsappFormatter);
  applyColumnCell('userStatus', userStatusFormatter);
  applyColumnCell('actions', actionsFormatter);
  applyColumnCell('firstName', linkFormatter);
  applyColumnCell('SNo', (cell) => showSequenceNumber(cell, filters));

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: data?.traders?.totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };
  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  useEffect(() => {
    const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');
    const unsubscribe = subscribeToMore({
      document: VENDORS_QUERY_SUBSCRIPTION,
      variables: {
        ...filters,
        filter: [
          ...deletedObj,
          ...subscriberType,
          ...planExpiringType,
          ...deviceAndRoleFilters,
          ...createdAtFilter,
          { key: 'kycStatus', value: kycStatus, type: 'STRING', op: 'EQ' },
        ],
      },
      updateQuery: (prev, { subscriptionData }) => {
        // console.log('subscriptionData', subscriptionData);
        const newData = cloneDeep(prev);
        const indexFound = newData?.traders?.traders.findIndex(
          (val) => val.id === subscriptionData.data.traders.trader.id,
        );
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (!subscriptionData.data?.traders?.trader?.id) return prev;
        if (subscriptionData.data.traders.action === 'CREATED') {
          const newTrader = subscriptionData.data.traders.trader;
          const updatedTraders = [newTrader, ...newData.traders.traders];

          const newTotalCount = prev.traders.totalCount + 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          newData.traders = {
            ...newData.traders,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            traders: updatedTraders,
          };
        }
        if (subscriptionData.data.traders.action === 'UPDATED') {
          newData.traders.traders[indexFound] =
            subscriptionData.data.traders.trader;
        }

        if (subscriptionData.data.traders.action === 'DELETED') {
          const { id } = subscriptionData.data.traders.trader; // ID of the trader to remove
          const prevTraders = prev.traders.traders;

          const updatedTraders = prevTraders.filter((val) => val.id !== id);

          const newTotalCount = prev.traders.totalCount - 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          const updatedTradersData = {
            ...newData.traders,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            traders: updatedTraders,
          };

          newData.traders = updatedTradersData;
        }
        return newData;
      },
    });

    return () => unsubscribe();
  }, [dateRange]);

  // useEffect(() => {
  //   const updatedFilter = [...filters.filter]; // Clone the filter array
  //   const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
  //   updatedFirstFilter.value = searchString;
  //   updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
  //   // return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
  //   refetch({ ...filters, filter: updatedFilter });
  // }, [searchString]);

  // const onGlobalSearch = (str) => {
  //   if (str) {
  //     setFilters((prevFilter) => {
  //       const updatedFilter = [...prevFilter.filter]; // Clone the filter array
  //       const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
  //       updatedFirstFilter.value = str;
  //       updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
  //       return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
  //     });
  //   }
  // };

  const onSelectedRowsChange = async (rows) => {
    await setRowSelection(rows);
  };

  const getMobileControl = (item, vendor) => {
    switch (item.control) {
      case 'paymentTerms':
        return paymentTermsFormatter({ row: { original: vendor, index: 0 } });
      case 'whatsapp':
        return whatsappFormatter({ row: { original: vendor } });
      case 'tdsEligible':
        return tdsEligibleFormatter({ row: { original: vendor } });
      case 'userStatus':
        return userStatusFormatter({ row: { original: vendor } });
      case 'kycStatus':
        return statusFormatter({ row: { original: vendor } });
      case 'role':
        return roleFormatter({ row: { original: vendor } });
      case 'flag': {
        const traderTag = getVendorTag(vendor);
        return (
          <FlagCell
            initialColor={traderTag?.colorCode}
            initialText={traderTag?.tagName}
            userId={vendor?.id}
          />
        );
      }
      default:
        return null;
    }
  };

  const renderMobileDetailValue = (item, vendor) => {
    if (item.control) {
      return (
        <div className="vendor-mobile-card__control-wrap">
          {getMobileControl(item, vendor)}
        </div>
      );
    }

    if (item.tone === 'status' || item.tone === 'badge') {
      return (
        <span
          className={`vendor-mobile-card__pill ${getMobileStatusClass(item.value)}`}
        >
          {item.value}
        </span>
      );
    }

    return item.value;
  };

  const handleMobileTabChange = (vendorId, tab) => {
    setActiveMobileTabs((prev) => ({
      ...prev,
      [vendorId]: tab,
    }));
  };

  const toggleMobileCard = (vendorId) => {
    setExpandedCardId((prev) => (prev === vendorId ? null : vendorId));
  };

  const totalPages = data?.traders?.totalPages || 0;
  const currentPageNo = filters.pageNo;
  const currentPageSize = filters.pageSize;

  const getTableInstance = (instance) => {
    // console.log('table instance ', instance);
    if (!tableRef.current) {
      tableRef.current = instance;
    }
  };

  if (loading)
    return (
      <div className="mt-3">
        <Loader />
      </div>
    );
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.traders?.traders)
    return <NoDataFound message="Traders not available" />;

  return (
    <>
      <DownloadCSV
        lazyQuery={EXPORTS_TRADERS}
        filters={{
          ...filters,
          filter: [
            ...filters.filter,
            ...subscriberType,
            ...planExpiringType,
            ...deviceAndRoleFilters,
            ...createdAtFilter,
            { key: 'kycStatus', value: kycStatus, type: 'STRING', op: 'EQ' },
          ],
        }}
        apiKey="exportTraders"
        fileName="ForeignVendors"
        classWrapper="vendor-download-btn"
        positionTop={
          Object.keys(rowSelection).length || subscriberType.length
            ? '-80px'
            : '-30px'
        }
      />

      <div className="vendor-mobile-list">
        {(data?.traders?.traders || []).map((vendor, index) => {
          const activeTab =
            activeMobileTabs[vendor.id] || MOBILE_FOREIGN_VENDOR_TABS[0];
          const sections = getForeignVendorMobileSections(
            vendor,
            index,
            filters,
          );
          const activeSection = sections[activeTab] || [];
          const summaryPlan = getVendorPlanName(vendor);
          const summaryOs = getVendorOs(vendor);
          const isExpanded = expandedCardId === vendor.id;

          return (
            <div className="vendor-mobile-card" key={vendor.id}>
              <div className="vendor-mobile-card__summary">
                <button
                  type="button"
                  className="vendor-mobile-card__identity"
                  onClick={(event) => {
                    event.stopPropagation();
                    handleLinkClick(vendor);
                  }}
                >
                  <div className="vendor-mobile-card__name">
                    {getVendorDisplayName(vendor)}
                  </div>
                  <div className="vendor-mobile-card__meta">
                    {`ID ${vendor?.id || 'N/A'} | ${getVendorPhone(vendor)}`}
                  </div>
                </button>
                <div className="vendor-mobile-card__aside">
                  <span
                    className={`vendor-mobile-card__pill ${getMobileStatusClass(summaryPlan)}`}
                  >
                    {summaryPlan}
                  </span>
                  <div className="vendor-mobile-card__tools">
                    {summaryOs ? (
                      <span
                        className={`vendor-mobile-card__pill ${getMobileStatusClass(summaryOs)}`}
                      >
                        {summaryOs}
                      </span>
                    ) : null}
                    <button
                      type="button"
                      className={`vendor-mobile-card__expand-toggle ${isExpanded ? 'is-open' : ''}`}
                      onClick={(event) => {
                        event.stopPropagation();
                        toggleMobileCard(vendor.id);
                      }}
                      aria-expanded={isExpanded}
                      aria-label={
                        isExpanded
                          ? 'Collapse vendor details'
                          : 'Expand vendor details'
                      }
                    >
                      <FaChevronDown />
                    </button>
                    <VendorActionDropdown
                      rowData={vendor}
                      tableName="ALL"
                      handleClickEdit={handleClickEdit}
                      toggleDeleteRecord={toggleDeleteRecord}
                      drawerEmailToggle={drawerEmailToggle}
                      toggleDeactivatePlan={toggleDeactivatePlan}
                      toggleClassName="vendor-mobile-card__action-toggle"
                      showVendorLogin
                    />
                  </div>
                </div>
              </div>

              {isExpanded && (
                <div className="vendor-mobile-card__body">
                  <div className="vendor-mobile-card__tabs">
                    {MOBILE_FOREIGN_VENDOR_TABS.map((tab) => (
                      <button
                        key={tab}
                        type="button"
                        className={`vendor-mobile-card__tab ${activeTab === tab ? 'active' : ''}`}
                        onClick={() => handleMobileTabChange(vendor.id, tab)}
                      >
                        {tab}
                      </button>
                    ))}
                  </div>

                  <div className="vendor-mobile-card__detail-list">
                    {activeSection.map((item) => (
                      <div
                        className="vendor-mobile-card__detail-row"
                        key={item.label}
                      >
                        <div className="vendor-mobile-card__detail-label">
                          {item.label}
                        </div>
                        <div className="vendor-mobile-card__detail-value">
                          {renderMobileDetailValue(item, vendor)}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {totalPages ? (
        <div className="vendor-mobile-pagination">
          <span className="vendor-mobile-pagination__count">
            {currentPageNo} of {totalPages}
          </span>
          <select
            className="page-select form-select table-select f-12 fw-normal vendor-mobile-pagination__select"
            value={currentPageSize}
            onChange={(e) => {
              const nextPageSize = Number(e.target.value);
              handlePageChange({
                pageNo: totalPages === currentPageNo ? 1 : currentPageNo,
                pageSize: nextPageSize,
              });
            }}
          >
            {[10, 20, 30, 40, 50].map((size) => (
              <option key={size} value={size}>
                {size} per page
              </option>
            ))}
          </select>
          <div className="pagination vendor-mobile-pagination__actions">
            <button
              type="button"
              onClick={() =>
                handlePageChange({ pageNo: 1, pageSize: currentPageSize })
              }
              disabled={currentPageNo <= 1}
            >
              {'<<'}
            </button>
            <button
              type="button"
              onClick={() =>
                handlePageChange({
                  pageNo: currentPageNo - 1,
                  pageSize: currentPageSize,
                })
              }
              disabled={currentPageNo === 1}
            >
              {'<'}
            </button>
            <button
              type="button"
              onClick={() =>
                handlePageChange({
                  pageNo: currentPageNo + 1,
                  pageSize: currentPageSize,
                })
              }
              disabled={currentPageNo >= totalPages}
            >
              {'>'}
            </button>
            <button
              type="button"
              onClick={() =>
                handlePageChange({
                  pageNo: totalPages,
                  pageSize: currentPageSize,
                })
              }
              disabled={currentPageNo >= totalPages}
            >
              {'>>'}
            </button>
          </div>
        </div>
      ) : null}

      <div className="vendor-mobile-hide-table">
        <FSBTable
          getRowId={(row) => row.id}
          data={(data && data?.traders?.traders) || []}
          totalCount={(data && data?.traders?.totalCount) || 0}
          totalPages={(data && data?.traders?.totalPages) || 0}
          columns={foreignVendorColumns}
          currentPageNo={filters.pageNo}
          pageSize={filters.pageSize}
          keyField="id"
          showSearch={false}
          showFilters={false}
          showDelete={false}
          showPagination
          remote
          tableClass="action-table"
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="table-responsive word-break"
          handlePageChange={handlePageChange}
          onSortChange={onSortChange}
          sorting={sortBy}
          searchPlaceholder="Search Vendors"
          onSelectedRowsChange={onSelectedRowsChange}
          rowSelection={rowSelection}
          getTableInstance={getTableInstance}
        />
      </div>
    </>
  );
};
export default CommonForeignVendorTable;
